<script>
import { orderPaymentMethodMap, bankTypeList } from '@utils/filter-value-to-text'

import lazyLoadComponent from '@router/lazyload-component'

export default {
  components: {
    InstallmentPaymentTable: () => lazyLoadComponent(import('@components/Orders/components/InstallmentPaymentTable')),
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    paymentWay: {
      type: String,
      default: 'offline',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    priceTotal: {
      type: Number,
      default: 0,
    },
    installmentOrder: {
      type: Object,
      default: () => {},
    },
    handleDialogStatus: {
      type: String,
      default: '',
      // 包月訂單延遲付款orderPagePayment
      // 預約合併包月reservationAndPrepaid
    },
  },
  data() {
    return {
      bankTypeList,
      paymentStep: 1,
      submitData: {
        paymentMethod: '',
        Card4No: '',
        PayerAccount5Code: '',
        bankType: '',
      },
      installmentForm: {
        total: 0,
        installments: 2,
        installmentAmount: [],
      },
      assignAmountVisible: false,
      installmentTableVisible: false,
    }
  },
  computed: {
    // 中租付款只對特定商家開放
    hasChailease() {
      return this.$store.state.merchant.cached.alias === 'naturalpan'
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (val === false) {
          setTimeout(() => {
            this.paymentStep = 1
          }, 1000)
        }
        this.$emit('update:visible', val)
      },
    },
    submitRules() {
      return {
        bankType: [
          {
            required: this.submitData.paymentMethod === 'Vacc',
            message: '請選擇轉帳銀行',
          },
        ],
        Card4No: [
          {
            // required: !!this.submitData.Card4No,
            pattern: !!this.submitData.Card4No ? /^[0-9]{4}$/ : '',
            message: '請輸入四碼數字',
            trigger: 'blur',
          },
        ],
        PayerAccount5Code: [
          {
            // required: !!this.submitData.PayerAccount5Code,
            pattern: !!this.submitData.PayerAccount5Code ? /^[0-9]{5}$/ : '',
            message: '請輸入五碼數字',
            trigger: 'blur',
          },
        ],
      }
    },
    paymentTitle() {
      return orderPaymentMethodMap[this.submitData.paymentMethod]
    },
    installmentUnpaid() {
      if (this.paymentWay === 'installments') {
        this.submitData.paymentMethod = 'Installment'
        const paidNum = this.installmentForm.installmentAmount.reduce((acc, cur) => (parseInt(acc) || 0) + (parseInt(cur) || 0), 0)
        if (this.installmentForm.total - paidNum < 0) this.$message.error('超出總付款金額')
        return this.installmentForm.total - paidNum
      }
    },
    installmentLoading() {
      return Boolean(this.installmentOrder?.installments?.length)
    },
  },
  watch: {
    priceTotal: {
      handler(nvl) {
        this.installmentForm.total = nvl
      },
      immediate: true,
    },
    handleDialogStatus: {
      handler(nvl) {
        // 包月訂單延遲付款
        if (nvl === 'orderPagePayment') {
          this.installmentTableVisible = true
        }
      },
      immediate: true,
    },
  },
  methods: {
    onSelectPaymentMethod(payment) {
      const resetPaymentInfo = () => {
        this.submitData.Card4No = ''
        this.submitData.PayerAccount5Code = ''
        this.submitData.bankType = ''
      }
      resetPaymentInfo()

      this.submitData.paymentMethod = payment
      if (payment === 'Credit') {
        this.onClickSubmit()
        return
      }

      this.paymentStep++
    },
    async onClickSubmit(isPaid = false) {
      if (this.$refs.form) await this.$refs.form.validate()
      this.$emit('submit', { ...this.submitData, isPaid })
      this.closeDialog()
    },
    closeDialog() {
      this.dialogVisible = false
    },
    openDialog() {
      this.dialogVisible = true
      console.log(this.dialogVisible)
    },
    async installmentStatusManage(command) {
      // 分配各期付款金額
      switch (command) {
        case 'back':
          this.installmentForm = {
            total: this.priceTotal,
            installments: 2,
            installmentAmount: [],
          }
          this.assignAmountVisible = false
          break
        case 'assign':
          if (this.installmentForm.installments > 12) {
            this.$message.error('分期數不得大於12期')
            this.installmentForm.installments = 12
            return
          }
          if (this.installmentForm.installments < 2 || !this.installmentForm.installments) {
            this.$message.error('分期數不得小於2期')
            this.installmentForm.installments = 2
            return
          }
          this.assignAmountVisible = true
          this.installmentForm.installmentAmount = Array.from({ length: this.installmentForm.installments }, () => 0)
          break
        // 儲存訂單
        case 'store':
          // 付款防呆
          const result = this.installmentForm.installmentAmount.some((item) => item === 0 || Number.isNaN(item))
          if (result) {
            this.$message.error('付款金額不得為0或空')
            return
          }

          // 訂單合併包月變更付款方式
          if (this.handleDialogStatus === 'reservationAndPrepaid') {
            const data = {
              ...this.installmentOrder,
              installments: this.installmentForm.installmentAmount,
            }
            await this.$emit('update', data)
            this.closeDialog()
            return
          }
          // 分期付款走這支
          const data = {
            installments: this.installmentForm.installmentAmount,
            isPaid: false,
            ...this.submitData,
          }
          await this.$emit('submit', data)
          this.installmentTableVisible = true
          break
      }
    },
    handleInput(index, value) {
      // 判斷要驗證的input
      const indexNum = parseInt(index)
      let num = parseInt(value, 10)
      // input值不能為負
      num = num < 0 ? 0 : num

      if (isNaN(indexNum)) {
        this.$set(this.installmentForm, 'installments', num)
      } else {
        this.$set(this.installmentForm.installmentAmount, index, num)
      }
    },
    closeDialogAndDrawer() {
      this.closeDialog()
      if (this.installmentOrder?.installments.length) this.$emit('close')
    },
  },
}
</script>
<template>
  <el-dialog :visible.sync="dialogVisible" width="550px" top="0" :close-on-click-modal="false" destroy-on-close append-to-body @close="closeDialogAndDrawer">
    <template v-if="paymentStep === 1">
      <div slot="title">
        <div style="margin-bottom: 10px">付款方式</div>
      </div>
      <div v-if="paymentWay === 'offline'">
        <el-button type="primary" class="is-round is-fullwidth" @click="onSelectPaymentMethod('Cash')"> 到店付款(現金) </el-button>
        <el-button type="primary" class="is-round is-fullwidth" @click="onSelectPaymentMethod('StoreCredit')"> 現場信用卡 </el-button>
        <el-button type="primary" class="is-round is-fullwidth" @click="onSelectPaymentMethod('Atm')"> 線下匯款 </el-button>
        <el-button type="primary" class="is-round is-fullwidth" @click="onSelectPaymentMethod('StoreLinePay')"> Line Pay </el-button>
        <el-button v-if="hasChailease" type="primary" class="is-round is-fullwidth" @click="onSelectPaymentMethod('Chailease')"> 中租零卡分期 </el-button>
      </div>
      <div v-if="paymentWay === 'online'">
        <el-button type="primary" class="is-round is-fullwidth" @click="onSelectPaymentMethod('Credit')"> 線上信用卡 </el-button>
        <el-button type="primary" class="is-round is-fullwidth" @click="onSelectPaymentMethod('Vacc')"> 虛擬帳戶 </el-button>
      </div>
    </template>
    <template v-if="paymentStep === 2">
      <div slot="title">
        <p style="margin-bottom: 10px">{{ paymentTitle }}</p>
      </div>
      <template>
        <!-- 現金付款 -->
        <template v-if="submitData.paymentMethod === 'Cash'">
          <div style="margin-bottom: 15px">客人是否已付款</div>
          <el-button type="primary" class="is-round is-fullwidth mt-3" :disabled="loading" :loading="loading" @click="onClickSubmit(true)"> 是 </el-button>
          <el-button class="is-round is-fullwidth" :disabled="loading" :loading="loading" @click="onClickSubmit()"> 否 </el-button>
        </template>
        <!-- 信用卡 匯款後四碼part -->
        <template v-if="submitData.paymentMethod === 'StoreCredit'">
          <el-form ref="form" :model="submitData" :rules="submitRules">
            <el-form-item prop="Card4No" class="el-form-item--white-bg-border" label="信用卡末四碼">
              <div class="el-form-item el-form-item--white-bg-border">
                <el-input v-model="submitData.Card4No" maxlength="4" minlength="4" placeholder="請輸入"> </el-input>
              </div>
            </el-form-item>
          </el-form>
          <el-button type="primary" class="is-round is-fullwidth mt-3" :disabled="loading" :loading="loading" @click="onClickSubmit(true)"> 確認 </el-button>
          <el-button class="is-round is-fullwidth" :disabled="loading" :loading="loading" @click="onClickSubmit()"> 稍後付款 </el-button>
        </template>
        <!-- ATM 匯款後五碼part -->
        <template v-if="submitData.paymentMethod === 'Atm'">
          <el-form ref="form" :model="submitData" :rules="submitRules">
            <el-form-item prop="PayerAccount5Code" class="el-form-item--white-bg-border" label="匯款帳號末五碼">
              <div class="el-form-item el-form-item--white-bg-border">
                <el-input v-model="submitData.PayerAccount5Code" maxlength="5" minlength="5" placeholder="請輸入"> </el-input>
              </div>
            </el-form-item>
          </el-form>
          <el-button type="primary" class="is-round is-fullwidth mt-3" :disabled="loading" :loading="loading" @click="onClickSubmit(true)"> 確認 </el-button>
          <el-button class="is-round is-fullwidth" :disabled="loading" :loading="loading" @click="onClickSubmit()"> 稍後付款 </el-button>
        </template>
        <!-- 虛擬帳戶 -->
        <template v-if="submitData.paymentMethod === 'Vacc'">
          <el-form ref="form" :model="submitData" :rules="submitRules">
            <el-form-item prop="bankType" class="el-form-item--white-bg-border" label="轉帳銀行">
              <el-select v-model="submitData.bankType">
                <el-option v-for="(bank, index) in bankTypeList" :key="`bank-${index}`" :value="bank.id" :label="bank.title"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-button type="primary" class="is-round is-fullwidth mt-3" :disabled="loading" :loading="loading" @click="onClickSubmit()"> 確認 </el-button>
        </template>
      </template>
      <!-- Line Pay／中租付款 -->
      <template v-if="submitData.paymentMethod === 'StoreLinePay' || submitData.paymentMethod === 'Chailease'">
        <div class="text-center" style="margin-bottom: 15px">是否確認付款</div>
        <el-button type="primary" class="is-round is-fullwidth mt-3" :disabled="loading" :loading="loading" @click="onClickSubmit(true)"> 是 </el-button>
        <el-button class="is-round is-fullwidth" :disabled="loading" :loading="loading" @click="closeDialog"> 否 </el-button>
      </template>
    </template>

    <!-- 分期付款 -->
    <template v-if="paymentWay === 'installments' && !installmentTableVisible">
      <div :class="$style['payList__installment']">
        <el-form :model="installmentForm" :class="$style['payList__installment__form']">
          <p class="mb-4 fw-medium"
            >總付款金額：<span class="text-primary fw-regular">NT${{ installmentForm.total }}</span></p
          >
          <p class="mb-4 fw-medium text-danger" v-if="assignAmountVisible">剩餘未分配金額：NT${{ installmentUnpaid }}</p>
          <div class="pb-4 mb-4" :class="$style['payList__installment__times']">
            <span class="fs-sm">分期付款期數</span>
            <span class="fs-sm" v-if="assignAmountVisible">{{ installmentForm.installments }}期</span>
            <div class="d-flex align-items-center" v-if="!assignAmountVisible">
              <el-input type="number" v-model="installmentForm.installments" class="mr-3 no-number" @input="handleInput(null, $event)"></el-input>期
            </div>
          </div>
          <div v-if="assignAmountVisible" class="mb-4" :class="$style['payList__installment__amount']">
            <el-row :gutter="10" type="flex" align="middle" class="mb-4" v-for="time in parseInt(installmentForm.installments)" :key="time">
              <el-col :span="8">{{ `第${time}期付款金額：` }}</el-col>
              <el-col :span="14">
                <el-input type="number" placeholder="請輸入金額" v-model="installmentForm.installmentAmount[time - 1]" @input="handleInput(time - 1, $event)"></el-input>
              </el-col>
              <el-col :span="1">元</el-col>
            </el-row>
          </div>
          <div class="mb-3">
            <el-button v-if="!assignAmountVisible" type="primary" round class="w-100" @click="installmentStatusManage('assign')">下一步</el-button>
            <el-button
              v-else-if="handleDialogStatus === 'reservationAndPrepaid' && assignAmountVisible"
              type="primary"
              round
              class="w-100"
              @click="installmentStatusManage('store')"
              :disabled="installmentUnpaid !== 0"
              >完成</el-button
            >
            <el-button v-else-if="assignAmountVisible" type="primary" round class="w-100" @click="installmentStatusManage('store')" :disabled="installmentUnpaid !== 0">前往付款</el-button>
          </div>
          <div v-if="assignAmountVisible">
            <el-button round class="w-100" @click="installmentStatusManage('back')">回上一步</el-button>
          </div>
        </el-form>
      </div>
    </template>

    <!-- 單期付款表單 -->
    <template v-if="installmentTableVisible">
      <InstallmentPaymentTable :installment-order="installmentOrder" :is-prepaid="true" @close="closeDialogAndDrawer" v-loading="!installmentLoading"></InstallmentPaymentTable>
    </template>
  </el-dialog>
</template>
<style lang="scss" module>
@import '@design';

.payList__installment {
  width: 100%;

  &__form {
    padding: 18px 36px;
    background-color: #fff;
    border-radius: 4px;

    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &__times {
    border-bottom: 0.5px solid $color-primary;

    span {
      margin-bottom: 4px;
    }
  }

  &__amount {
    border-bottom: 0.5px solid $color-primary;
  }
}
</style>
